import * as React from 'react'
import { Page, Table, Card, Modal } from '@comps'
import {Layout, Http, Message, Env, Context} from '@utils'
import { ColumnProps } from '@comps/types'
import {Button, Form, Input, Upload, Space, Spin} from 'antd'
import { Link } from 'react-router-dom'
import { OrgDetail } from './detail';
import {UploadOutlined} from "@ant-design/icons";
import {UploadChangeParam} from "antd/lib/upload";
import {useState} from "react";

const Item = Form.Item

const OrgList: React.FC = (props: any) => {
  let [uploading, setUploading] = useState(false)
  const [form] = Form.useForm();
  const [isModalVisible, setModalVisible] = React.useState(false)
  let [table, setTable] = React.useState<Table>();

  let path = props.match.path
  // 是否为客户资料管理
  let isCustomerMgr = '/org/customers' === path

  /**
   * 文件上传
   * @param info
   */
  const onUploadChange = (info: UploadChangeParam) => {
    //const [uploadingStatus, doneStatus, errorStatus] = ['uploading', 'done', 'error']
    let file: any = info.file
    let status = file.status

    switch (status) {
      case 'uploading':
        setUploading(true)
        Message.info("正在导入,请耐心等待15-30秒.")
        break
      case 'error':
        setUploading(false)
        Message.error("导入失败,出现未知错误,请联系运维人员检查")
        break
      case 'done':
        setUploading(false)
        let statusCode = file.response.code
        let tips = file.response.msg
        if (statusCode === '200') {
          Message.info("导入成功")
          table?.refresh()
        } else {
          Message.error("导入失败:" + tips)
        }
        break
    }
  }

  const createOrg = () => {
    form.validateFields().then(values => {
      let url = isCustomerMgr ? '/org/orgs/customers' : '/org/orgs'
      Http.post(url, values).then(data => {
        Message.saveOk()
        setModalVisible(false)
        form.resetFields()
        table?.refresh()
      })
    })
  }

  const download = () =>{
    let url =  Env.getBaseUrl() + '/org/orgs/download?accessToken' + Context.getToken() ;
    // Http.get(url, {})
    //   .then(res => {
    //
    //   })

    window.open(url, '_blank')
  }

  const enterAddModal = () => {
    setModalVisible(true)
  }

  const onCancel = () => {
    form.resetFields();
    setModalVisible(false)
  }

  const onTableRef = (tableRef: Table) => {
    table = tableRef
    setTable(tableRef)
  }

  const columns: ColumnProps[] = [
    {
      key: 'orgName', title: '企业名称', width: 260, fixed: 'left',
      render: (orgName, row, index) => (<Link to={`/org/${row.id}/edit`}>{orgName}</Link>),
    },
    { key: 'orgCode', title: '企业编码', width: 130, },
    { key: 'taxNo', title: '税号', width: 220, },
    { key: 'addrTel', title: '地址电话', width: 150, },
    { key: 'bankAccount', title: '银行账号', width: 150, },
  ];

  return (
    <Page>
      <Card title={isCustomerMgr ? '客户资料' : '公司管理'} actions={
        <Space>
          <Button type='primary' onClick={download}>模板下载</Button>
          <Upload name='uploadFile' showUploadList={false}
                  data={{orgType:isCustomerMgr ?'CUSTOMER':'CORE' }}
                  accept='.xls,.xlsx'
                  action={`${Env.getBaseUrl()}/org/orgs/importOrg`}
                  headers={{ authorization: Context.getToken() }}
                  onChange={onUploadChange}>
            <Spin spinning={uploading}><Button type='primary'><UploadOutlined /> 公司导入</Button></Spin>
          </Upload>
           <Button type='primary' onClick={enterAddModal}>创建公司</Button>
        </Space>}>
        <Table url={isCustomerMgr ? '/org/orgs/customers' : '/org/orgs'} columns={columns} rowKey='id' onTableRef={onTableRef}>
          <Input name='key' placeholder='公司名称/税号/编码' />
        </Table>
      </Card>

      <Modal title='新增' visible={isModalVisible}
        onCancel={onCancel}
        onOk={createOrg}>
        <Form name='form' form={form} {...Layout.modal_1c}>
          <Item name='orgName' label='公司名称' required><Input /></Item>
          <Item name='taxNo' label='税号' required><Input /></Item>
          <Item name='orgCode' label='编码' ><Input placeholder='未提供时系统将自动分配' /></Item>
        </Form>
      </Modal>
    </Page>
  )
}

export { OrgList, OrgDetail }
